import { z } from 'zod';
import { ApplicationSearchFiltersSchema, } from "./find-applications-by-facility.dto.js";
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
// Request validation schema
export const ListAllApplicationsPaginatedRequestDTOSchema = z.object({
    query: createPaginatedQuerySchema(ApplicationSearchFiltersSchema),
});
//# sourceMappingURL=list-all-applications.dto.js.map